<template>
  <v-dialog persistent v-model="dialog" max-width="800px">
    <template slot="activator">
      <slot>
        <v-btn
          fixed
          fab
          bottom
          right
          color="primary"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </slot>
    </template>
    <!--<slot>-->

    <!--</slot>-->
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">Gast Erstellen</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs6>
                <v-select
                  :items="genders"
                  v-model="guest.gender"
                  label="Anrede"
                  single-line
                  :disabled="loading"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Titel"
                  v-model="guest.title"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Vorname"
                  v-model="guest.forename"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Nachname"
                  v-model="guest.surname"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Email"
                  required
                  v-model="guest.email"
                  :rules="emailRules"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-switch
                  :label="`Per ${guest.formal ? 'Sie' : 'Du'}`"
                  v-model="guest.formal"
                  :disabled="loading"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="cancel()" :disabled="loading">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="save()" :loading="loading">Erstellen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'DlgGuestNew',
    data() {
      return {
        dialog: false,
        guest: {
          formal: true,
        },
        loading: false,
        valid: true,
        emailRules: [
          (v) => !!v || 'E-mail ist ein Pflichtfeld',
          (v) => /.+@.+/.test(v) || 'E-mail ist ungültig',
        ],
        genders: [
          {
            text: 'Weiblich',
            value: 'female',
          },
          {
            text: 'Männlich',
            value: 'male',
          },
        ],
      };
    },
    computed: {
      ...mapGetters({
      }),
    },
    methods: {
      ...mapActions({
        createGuest: 'admin/guests/create',
        readGuests: 'admin/guests/read',
      }),
      save() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.createGuest(this.guest).then((guest) => {
            this.loading = false;
            if (guest) {
              this.$emit('added', guest);
              this.guest = {
                formal: true,
              };
              this.readGuests();
              this.dialog = false;
              this.valid = true;

            }
          });
        }
      },
      cancel() {
        this.dialog = false;
        this.guest = {};
      },
    },
  };
</script>

<style scoped>

</style>
